import React from "react";
import MdaeDrawerListItemTemplate from "./mdae-drawer-menu-list-item-template";
import { useSelector, useDispatch } from "react-redux";
import { isEqual } from "lodash";
import MdaeList from "../list";
import { SET_MDAE_NAVIGATION_BAR_CONFIG } from "./reducers/mdae-navigation-bar-reducer";
import DataSource from "devextreme/data/data_source";
import { mdaeNewNavigationBarConfig } from "./mdae-navigation-bar-config";
import $ from "jquery";
const MdaeDrawerMenuListTemplate: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const mdaeNavigationBarItemList = useSelector(
    (state) => state["mdaeNavigationBarReducer"].mdaeNavigationBarItemList,
    isEqual
  );
  mdaeNavigationBarItemList?.forEach((element) => {
    element.selected = false;
  });
  return (
    <MdaeList
      id={"pnlMdaeDxMenuList"}
      dataSource={
        new DataSource({
          store: mdaeNavigationBarItemList,
          pageSize: 100,
        })
      }
      onContentReady={(e) => {
        setTimeout(function() {
          const dxItemDomList = $("#pnlMdaeDxMenuList")
            .find("div.dx-item.dx-list-item")
            .toArray();
          e.component.option("items").forEach((item, index) => {
            if (item.menuSectionTitle)
              dxItemDomList[index].classList.add(
                "mdae-menu-item-section-border"
              );
          });
          const currentMenuItem = mdaeNewNavigationBarConfig.selectMdaeDxMenuListItem(
            e.component,
            props.history.location.pathname + props.history.location.search
          );
          if (
            currentMenuItem &&
            currentMenuItem.menuItem.pageTitle &&
            currentMenuItem.menuItem.pageTitle !== props.mdaePageTitle
          )
            dispatch({
              type: SET_MDAE_NAVIGATION_BAR_CONFIG,
              data: { mdaePageTitle: currentMenuItem.menuItem.pageTitle },
            });
        }, 500);
      }}
      selectionMode={"single"}
      noDataText={""}
      pageLoadMode={"scrollBottom"}
      width={props.mdaeNavigationBarListWidth}
      itemRender={(item) => {
          return (
            <MdaeDrawerListItemTemplate
              auditsSectionMenuItemListItem={item}
              changePageLocation={(
                menuUrl,
                isOpenInNewTab,
                mdaeMenuClickHandler,
                isReactMenu
              ) => {
                if (
                  mdaeMenuClickHandler &&
                  typeof mdaeMenuClickHandler === "function"
                )
                  mdaeMenuClickHandler(dispatch);
                else {
                  if (isReactMenu) {
                    if (isOpenInNewTab) window.open(menuUrl, "_blank");
                    else props.history.push(menuUrl);
                  } else {
                    if (
                      mdaeMenuClickHandler &&
                      typeof mdaeMenuClickHandler === "function"
                    )
                      mdaeMenuClickHandler(dispatch);
                    else if (menuUrl) {
                      if (isOpenInNewTab) window.open(menuUrl, "_blank");
                      else window.location.href = menuUrl;
                    }
                  }
                }
              }}
              mdaeNewNavigationBarConfig={{
                hasItemAnySubmenu: (auditsSectionMenuItemListItem) => {
                  return (
                    auditsSectionMenuItemListItem.items &&
                    auditsSectionMenuItemListItem.items.length
                  );
                },
              }}
            ></MdaeDrawerListItemTemplate>
          );
      }}
    ></MdaeList>
  );
};
export default MdaeDrawerMenuListTemplate;
